import { Play } from "lucide-react";
import { IMAGES, MAGAZINE, SOCIAL } from "../../data/content";
import { SponsorGrid } from "./SponsorGrid";

export const MediaSponsor = () => (
  <section
    id="capitolo-2"
    data-testid="media-section"
    className="py-24 bg-neutral-900 border-b border-neutral-800"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-12">
        <h2 className="font-display text-3xl sm:text-4xl font-black uppercase text-white">
          Prove in Video & Partner
        </h2>
        <p className="text-sm text-neutral-400 mt-1">
          La playlist storica del Finnico su YouTube e i loghi degli sponsor ufficiali.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-8">
        <div className="lg:col-span-7">
          <div data-testid="playlist-title" className="flex items-center gap-3 mb-3">
            <span className="w-2 h-2 bg-red-600" />
            <h3 className="font-display text-lg sm:text-xl font-black uppercase text-white">
              Playlist di vecchie glorie
            </h3>
          </div>
          <div className="aspect-video border border-neutral-800 bg-black">
            <iframe
              data-testid="youtube-playlist"
              title="Video storici del Finnico — playlist YouTube Legend Team"
              src={`https://www.youtube-nocookie.com/embed/videoseries?list=${SOCIAL.storiaPlaylistId}&rel=0`}
              className="w-full h-full"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
          <div className="flex flex-wrap items-center justify-between gap-3 mt-3">
            <div>
              <span className="mono-label text-xs text-red-500 font-bold uppercase tracking-wider">
                Playlist &bull; I video storici del Finnico
              </span>
              <p className="text-xs text-neutral-400 mt-0.5">
                Prove speciali, camera car e archivio Finnico Corse dal canale @LegendTeamASD.
              </p>
            </div>
            <div className="flex items-center gap-4 mono-label text-xs uppercase tracking-wider">
              <a data-testid="youtube-playlist-link" href={SOCIAL.storiaPlaylistUrl} target="_blank" rel="noopener noreferrer" className="text-neutral-300 hover:text-red-500">
                Apri playlist &rarr;
              </a>
              <a data-testid="youtube-slot" href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-red-500 hover:text-red-400">
                <Play className="w-3.5 h-3.5 fill-current" /> Canale YouTube
              </a>
            </div>
          </div>
        </div>
        <div className="lg:col-span-5 bg-neutral-950 p-8 border border-neutral-800 flex flex-col justify-between">
          <div>
            <div className="mono-label text-xs text-red-500 uppercase tracking-wider mb-2">
              08 slot &bull; loghi cliccabili
            </div>
            <h3 className="font-display text-xl font-bold uppercase text-white mb-4">
              Sponsor & Partner Tecnici
            </h3>
            <p className="text-xs text-neutral-300 leading-relaxed">
              Ringraziamo le aziende che sostengono l'attività agonistica, gli eventi e la
              crescita del Legend Team. Ogni logo rimanda al sito ufficiale del partner: nel
              motorsport nessuno corre davvero da solo.
            </p>
            <a
              data-testid="magazine-partner-box"
              href={MAGAZINE.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group block mt-5 bg-white p-4 border border-neutral-800 hover:border-red-600 transition-colors"
            >
              <img src={IMAGES.logoMagazine} alt="Legend Magazine — il magazine di chi vive il motorsport con passione" className="h-10 w-auto" loading="lazy" />
              <p className="text-xs text-neutral-800 leading-relaxed mt-3">
                Abbiamo ufficialmente creato la testata giornalistica <strong>Legend Magazine</strong>:
                per partner e sponsor ci sono ottime novità sui bonus di visibilità.
              </p>
              <span className="inline-block mt-2 mono-label text-[11px] font-bold uppercase tracking-widest text-red-600 group-hover:text-red-500">
                legendmagazine.it &rarr;
              </span>
            </a>
          </div>
          <a
            data-testid="sponsor-cta"
            href="#contact"
            className="mt-6 inline-block text-xs uppercase tracking-widest font-bold text-red-500 hover:text-red-400"
          >
            Diventa partner del team &rarr;
          </a>
        </div>
      </div>

      <div data-testid="sponsor-title" className="flex items-end justify-between gap-4 mb-4 border-b border-neutral-800 pb-3">
        <div>
          <h3 className="font-display text-xl sm:text-2xl font-black uppercase text-white">
            I nostri sponsor
          </h3>
          <p className="text-xs text-neutral-400 mt-0.5">Clicca un logo per visitare il sito del partner.</p>
        </div>
        <span className="mono-label text-xs text-red-500 uppercase tracking-wider">Stagione 2026</span>
      </div>
      <SponsorGrid />
    </div>
  </section>
);
